import { Form } from 'antd';
import ImplementSelect from 'app/components/Select/ImplementSelect/ImplementSelect';
import { FC } from 'react';
import { getImplementFormItemName } from '../AddRouteToTaskDrawer/AddRouteToTaskDrawer.helpers';

interface IProps {
  routeId: number;
}

const RouteImplementSelect: FC<IProps> = ({ routeId }) => {
  return (
    <Form.Item
      name={getImplementFormItemName(routeId)}
      style={{ marginBottom: 0 }}
    >
      <ImplementSelect
        allowClear
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => {
          const label = (option?.label as string)?.toLowerCase();
          return label?.includes(input.toLowerCase());
        }}
        style={{ width: 184 }}
      />
    </Form.Item>
  );
};

export default RouteImplementSelect;
